module.exports = __webpack_public_path__ + "media/images/cplook/social_icons-5cb3358381730753324f71074a1f9c89.png";